// Socket's owner-only projection reports account-wide admission separately
// from effective rendering concurrency. Neither is a per-tab plan allowance.
export function imagePaymentModel(slot, balance = {}) {
  if (slot.projectConfig.billingMode === 'subscription') return 'subscription';
  return slot.premium || Number(balance.premiumSpark) > 0 ? 'paid_spark' : 'free_spark';
}

export function getImageAdmission(capacity, slot, balance = {}) {
  const paymentModel = imagePaymentModel(slot, balance);
  const scope = paymentModel === 'subscription' ? 'account_media' : 'account_all';
  const admission = capacity?.admission?.find(entry => entry.paymentModel === paymentModel && entry.scope === scope);
  const limit = admission?.limit;
  if (!limit || limit.status === 'unavailable') {
    return { status: 'unavailable', paymentModel, scope, canSubmit: false,
      message: 'Your account capacity could not be confirmed. Refresh capacity before submitting the remaining images.' };
  }
  const numeric = limit.status === 'available';
  const used = Number(admission.used);
  const ceiling = numeric ? Number(limit.value) : null;
  const available = numeric ? Math.max(0, ceiling - used) : null;
  const poolId = slot.partner ? 'partner_media'
    : paymentModel === 'subscription' ? `supernet_non_video_${slot.projectConfig.network}`
      : paymentModel === 'paid_spark' ? 'supernet_media' : 'supernet_non_video';
  const pool = capacity.pools.find(entry => entry.id === poolId);
  const concurrency = capacity.concurrency.find(entry => entry.paymentModel === paymentModel
    && entry.poolId === poolId && entry.mode === 'media');
  return {
    status: available === 0 ? 'full' : 'available', paymentModel, scope,
    used, limit: ceiling, remaining: available, canSubmit: available !== 0,
    active: pool?.active ?? null, waiting: pool?.waiting ?? null,
    concurrencyLimit: concurrency?.limit.status === 'available' ? concurrency.limit.value : null,
    concurrencyStatus: concurrency?.limit.status || 'unavailable',
    network: slot.projectConfig.network, poolId,
    message: available === 0
      ? 'Your account queue is full, including work in other Sogni apps. The remaining images stay saved without being submitted.' : null
  };
}
